/* ==========================================================================
   OMNI Quiz Vol. 4 - Funnel 1 · Energy (Women 35+)
   Copy follows the Figma "SPs - Support Pages" frames; flow, branching and
   scoring follow omni-quiz-funnel.html (Scoring & Personalization v4).
   Option order matters: scoring in quiz-vol4-engine.js reads answer indices.
   ========================================================================== */
(function () {
  'use strict';

  var S = {
    single: 'Please select one',
    multi: 'Please select all that apply'
  };

  window.OMNI_QUIZ_V4_FUNNELS = window.OMNI_QUIZ_V4_FUNNELS || {};

  window.OMNI_QUIZ_V4_FUNNELS.energy = {
    id: 'energy',
    name: 'Creatine Energy Assessment',
    promo: 'OMNIQUIZ-ENERGY',

    /* Clinicians' Choice card: set the number and the 3 photos by hand */
    frontrow: {
      count: '675',
      photos: [
        'https://assets.app.thefrontrowhealth.com/yulyi33mil8glzv4b7fhzs5ipnz2',
        'https://assets.app.thefrontrowhealth.com/rdpnv5i5g5jmw9nl1c2udq4l2szf',
        'https://assets.app.thefrontrowhealth.com/pa8nliuewz7t7g0dmxjawwf0kr5a'
      ]
    },
    landing: {
      heroImage: 'energyHero',
      title: 'No matter how many diets you try, the weight comes back',
      lead: 'Women lose up to 30% of their natural creatine stores with age - making energy, body composition and recovery harder than they should be, no matter how disciplined you are.',
      question: 'Find out what’s making you <br>lose muscle, not fat',
      firstQ: 'gender'
    },

    steps: [
      { type: 'multi', id: 'goals', wide: true, title: 'What are your goals?', sub: S.multi,
        opts: ['More all-day energy', 'Muscle tone & strength', 'Lose weight & fat', 'Better body composition', 'Healthy aging'] },

      /* wide: the Figma frame lays this one out on the full 1280px — title on one line, four answers in a row */
      { type: 'single', id: 'wlhow', wide: true, title: 'How long have you been trying to lose weight?', sub: S.single,
        opts: ['This is my first real attempt', 'A few months', 'A few years', 'Most of my adult life'] },

      { type: 'single', id: 'rebound', title: 'What usually happens after you lose weight?', sub: S.single,
        opts: ['It comes back', 'It comes back - with extra', 'I hit a plateau and stall', 'I’ve never really lost it'],
        why: 'Diets that burn muscle lower your metabolism, so every round of weight loss makes the next rebound bigger. Protecting muscle breaks the cycle.' },

      { type: 'single', id: 'childhood', title: 'Which best describes you growing up?', sub: 'Your history helps us find your metabolic set point',
        opts: ['I was always the bigger kid', 'My weight went up and down', 'I was lean until my 20s-30s', 'Weight was never an issue until recently'],
        why: 'People who carried extra weight early in life have a higher ‘set point’ the body defends. It’s not a life sentence - but it means muscle, the body’s biggest calorie burner, matters even more for you.' },

      { type: 'single', id: 'diet', title: 'How often do you eat red meat or fish?', sub: 'The only natural sources of creatine in food',
        opts: ['Every day', 'A few times a week', 'Occasionally', 'Rarely / never (plant-based)'],
        why: 'Red meat and fish are the primary dietary sources of creatine. Plant-based eaters typically carry 20-30% lower creatine stores.' },

      { type: 'single', id: 'train', title: 'How often do you strength train?', sub: 'Bodyweight counts too',
        opts: ['Never', '1-2× a week', '3-4× a week', '5+ times a week'] },

      { type: 'single', id: 'changed', title: 'Have you noticed changes in your energy or body in the last year?', sub: S.single,
        opts: ['Yes', 'No'] },

      { type: 'multi', id: 'changes', wide: true, title: 'Which changes have you noticed?', sub: S.multi,
        showIf: function (a) { return a.changed == null || a.changed === 0; },
        opts: ['Tired even after sleeping', 'Softer, less toned muscles', 'Slower recovery after activity', 'Brain fog / forgetting words', 'Weight creeping up'] },

      { type: 'bodymap', id: 'areas', title: 'Where would you like to see change first?', sub: 'Please tap all areas that apply' },

      { type: 'multi', id: 'tried', title: 'What have you tried in the last year?', sub: S.multi,
        opts: ['Dieting / calorie counting', 'Intermittent fasting', 'More cardio', 'Protein shakes', 'Fat burners / supplements', 'Nothing yet'],
        none: [5] },

      { type: 'multi', id: 'habits', title: 'Do you sometimes tend to…', sub: S.multi,
        opts: ['Snack late at night', 'Stress eat', 'Crave sugar in the afternoon', 'Skip meals, then overeat', 'None of the above'],
        none: [4] },

      { type: 'single', id: 'hunger', title: 'How would you describe your hunger?', sub: S.single,
        opts: ['I’m hungry all the time', 'Fine all day - ravenous at night', 'I eat from stress or boredom, not hunger', 'Normal - hunger isn’t my problem'],
        why: 'Constant or evening hunger usually tracks blood-sugar swings and low muscle mass - muscle is where carbs get stored. More muscle, steadier hunger.' },

      { type: 'multi', id: 'symptoms', title: 'Do you experience any of the following?', sub: S.multi,
        opts: ['Brain fog / fatigue', '3pm energy crash', 'Heavy legs / weakness', 'Poor sleep quality', 'Sore for days after workouts', 'None of the above'],
        none: [5] },

      { type: 'multi', id: 'struggles', title: 'Do you struggle with any of the following?', sub: S.multi,
        opts: ['Losing muscle instead of fat', 'Cravings / low willpower late in the day', 'Low energy', 'None'],
        none: [3] },

      { type: 'info', id: 'info1', title: 'We got you!', lead: 'That’s exactly what creatine was made for.',
        image: 'infoPack',
        intro: 'With OMNI you get 3g of pure creatine monohydrate in a gummy',
        introMobile: 'With OMNI you get 3g of pure creatine monohydrate in a gummy - no powders, no bloating, no loading cycles:',
        bullets: ['Refills cellular energy (ATP) in muscle and brain', 'Supports lean muscle and faster recovery', 'Backed by 500+ clinical studies'],
        close: 'Let’s finish the quiz and get to your results.' },

      { type: 'single', id: 'exercise', h1: 40, title: 'Do you exercise?', sub: S.single,
        opts: ['Yes, I do', 'Sometimes', 'Not really'] },

      { type: 'multi', id: 'routine', title: 'What best describes your exercise routine?', sub: S.multi,
        showIf: function (a) { return a.exercise !== 2; },
        opts: ['Walking / light activities', 'Strength training / weight lifting', 'Cardio (running, cycling, swimming)', 'Yoga / Pilates', 'Sports / active hobbies', 'None of the above'],
        none: [5] },

      { type: 'single', id: 'sleep', h1: 40, title: 'How many hours of quality sleep do you get?', sub: S.single,
        opts: ['Less than 5 hours', '5-6 hours', '7-8 hours', 'More than 8 hours'] },

      { type: 'single', id: 'water', h1: 40, title: 'How much water do you drink a day?', sub: S.single,
        opts: ['A couple of glasses at most', '3-5 glasses', '6+ glasses / 2 liters'],
        why: 'Creatine pulls water into muscle cells to produce energy. Chronic low hydration keeps stores - and your metabolism - low.' },

      { type: 'single', id: 'meds', h1: 40, yn: true, title: 'Do you take any medications?', sub: S.single,
        opts: ['Yes', 'No'] },

      { type: 'multi', id: 'medlist', title: 'To understand your health better, which medications are you taking?', sub: S.multi,
        showIf: function (a) { return a.meds == null || a.meds === 0; },
        opts: ['GLP-1 (Ozempic, Wegovy, Zepbound...)', 'Blood pressure medication', 'Antidepressants', 'Hormones / HRT', 'Thyroid medication', 'None of the above'],
        none: [5] },

      { type: 'single', id: 'event', h1: 40, title: 'Is there a moment you’d love to look your best for?', sub: S.single,
        opts: ['A vacation or trip', 'A wedding or big event', 'A reunion - seeing old friends', 'No event - I’m doing this for me'] },

      { type: 'single', id: 'pace', h1: 40, title: 'How fast would you like to see results?', sub: S.single,
        opts: ['As fast as possible', 'Steady and sustainable', 'No rush - I’m playing the long game'] },

      { type: 'single', id: 'age', h1: 40, title: 'What age group are you in?', sub: S.single,
        opts: ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'] },

      { type: 'multi', id: 'hormones', title: 'Have you been through any of these hormonal changes?', sub: S.multi,
        showIf: function (a) { return a.gender === 'female'; },
        opts: ['Perimenopause or menopause', 'PCOS diagnosis', 'Thyroid condition', 'Pregnancy in the last 5 years', 'None of the above'],
        none: [4] },

      { type: 'height', id: 'height', title: 'What’s your height?' },
      { type: 'weight', id: 'weight', title: 'What’s your current weight & goal?',
        note: 'Results are not guaranteed. Creatine stores typically saturate in 3-4 weeks with daily use; body-composition changes depend on training and diet.' },
      { type: 'loader', id: 'loader', title: 'Building your creatine protocol...',
        checks: ['Evaluating your answers...', 'Estimating your creatine stores...', 'Matching clinical dosing data...', 'Building your protocol...'] },
      { type: 'email', id: 'email', label: 'Your match is ready', title: 'One step left to see your protocol',
        text: 'We’ll also let you know when <b>OMNI free samples</b> are available.' }
    ],

    /* ---- personalised result pages (R1-R7) + checkout ---- */
    results: {
      audience: '41,200+ women',
      matchedTo: 'Matched to your age group and goals.',
      chartTitle: 'Your energy & tone projection',
      guide: 'Creatine for Women',
      goal: function (delta, fmt) {
        return delta > 0 ? 'lose ' + fmt(delta) + ' and get your energy back' : 'get your tone & energy back';
      },
      reviews: [
        ['Jessica, 34', 'Week three I stopped needing the 3pm coffee. By week six my arms looked like they did at 30.'],
        ['Dana K., 47', 'I’ve tried everything for the afternoon slump. This is the first thing that worked without jitters.'],
        ['Priya S., 38', 'Brain fog gone. My deep-work mornings are noticeably sharper.']
      ]
    }
  };
})();
